import { render, staticRenderFns } from "./efatura.vue?vue&type=template&id=20bbea42&"
import script from "./efatura.vue?vue&type=script&lang=js&"
export * from "./efatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports